import React from 'react'

const OurBenefits = () => {
    return (
        <>

            <div className="our-benefits" style={{ marginTop: "-60px" }}>
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">
                            {/* Section Title Start */}
                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our Benefits</h3>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        
                                        Discover The Benefits That Set Our Food Products Apart
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 ordeer-1">
                            {/* Our Benefits List Start */}
                            <div className="our-benefits-list">
                                {/* Benefit Item Start */}
                                <div className="benefit-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-benefit-1.svg" alt />
                                    </div>
                                    <div className="benefit-item-content">
                                        <h3>Mahua Shakti Blend</h3>
                                        <p>Rich in natural nutrients Source of plant protein Supports daily energy and wellness.</p>
                                    </div>
                                </div>
                                {/* Benefit Item End */}
                                {/* Benefit Item Start */}
                                <div className="benefit-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-benefit-2.svg" alt />
                                    </div>
                                    <div className="benefit-item-content">
                                        <h3>Kaju (Cashew) & Badam (Almond)</h3>
                                        <p>KAJU and BADAM is a premium almond superfood that delivers natural nutrition, energy, and wellness with every crunchy bite.</p>
                                    </div>
                                </div>
                                {/* Benefit Item End */}
                                {/* Benefit Item Start */}
                                <div className="benefit-item wow fadeInUp" data-wow-delay="0.6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-benefit-3.svg" alt />
                                    </div>
                                    <div className="benefit-item-content">
                                        <h3>Chhuara (Dry Dates)</h3>
                                        <p>CHHUARA (Dry Dates) is a premium natural superfood that delivers wholesome energy, rich nutrition, and traditional goodness in every bite.</p>
                                    </div>
                                </div>
                                {/* Benefit Item End */}
                            </div>
                            {/* Our Benefits List End */}
                        </div>
                        <div className="col-lg-4 order-lg-2 order-md-3 order-2">
                            {/* Our Benefits Image Start */}
                            <div className="our-benefits-image">
                                <figure>
                                    <img src="assets/img/About us_4.png" alt />
                                </figure>
                            </div>
                            {/* Our Benefits Image End */}
                        </div>
                        <div className="col-lg-4 col-md-6 order-lg-3 order-md-2 order-3">
                            {/* Our Benefits List Start */}
                            <div className="our-benefits-list">
                                {/* Benefit Item Start */}
                                <div className="benefit-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-benefit-4.svg" alt />
                                    </div>
                                    <div className="benefit-item-content">
                                        <h3>Makhana</h3>
                                        <p>MAKHANA is a premium fox nut superfood that delivers light crunch, natural nutrition, and wholesome wellness in every bite.</p>
                                    </div>
                                </div>
                                {/* Benefit Item End */}
                                {/* Benefit Item Start */}
                                <div className="benefit-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-benefit-5.svg" alt />
                                    </div>
                                    <div className="benefit-item-content">
                                        <h3>Bhoni Moongfali And Bhuna Chana</h3>
                                        <p>BHONI MOONGFALI and BHUNA CHANA is a premium-quality roasted gram snack that combines traditional taste with wholesome nutrition.</p>
                                    </div>
                                </div>
                                {/* Benefit Item End */}
                                {/* Benefit Item Start */}
                                <div className="benefit-item wow fadeInUp" data-wow-delay="0.6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="assets/images/icon-benefit-6.svg" alt />
                                    </div>
                                    <div className="benefit-item-content">
                                        <h3>TIL (Sesame) & Chamsur (Garden Cress)</h3>
                                        <p >CHAMSUR (Garden Cress Seeds) is a premium traditional superfood that provides iron-rich nutrition, natural strength, and wholesome vitality in every serving.</p>
                                    </div>
                                </div>
                                {/* Benefit Item End */}
                            </div>
                            {/* Our Benefits List End */}
                        </div>

                    </div>
                </div>
            </div>


        </>
    )
}

export default OurBenefits